import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Note } from "../components/Note";
import { API } from "../core/api";
import { Form } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import { formatAntdJalaliDate, onChangeProvince } from "../core/utils";
import { parse, stringify } from "query-string";
import FileSaver from "file-saver";

const useCarsServiceReport = () => {
  const history = useHistory();
  const location = useLocation();
  const store = useSelector((state) => state.Store);
  const params = parse(location.search);
  const [loading, setLoading] = useState(false);
  const provinces = useSelector((state) => state.Store.provinces);
  const [users, setUsers] = useState([]);
  const [cities, setCities] = useState([]);
  const [categories, setCategories] = useState([]);
  const [cars, setCars] = useState([]);
  const [carsServiceReport, setCarsServiceReport] = useState([
    {
      id: 5001800,
      user: {
        id: 6009585,
        first_name: "Hussam",
        last_name: "Al-Zahrani",
        driver_phone_number: "0501166195",
      },
      product: {
        name: "Toyota Oil Filter for Hilux",
        category: "Oil",
      },
      payable_amount: 125.5,
      phone_number: "0112345678",
      user_car: {
        car_name: "Toyota Hilux",
        plate_number: "ب ج ح ٧٨٩٠ / B J H 7890",
        initial_km: 0,
      },
      service_center: {
        name: "Al-Rajhi Auto Service",
        phone_number: "0112345678",
        address: "Riyadh - Olaya District - King Fahd Road",
      },
      operator: {
        operator_id: 5001123,
        operator_name: "Mohammed Al-Saud",
        operator_username: "0501234567",
      },
      delivery_date: "2023/05/21",
      visit_date: "2023/05/22",
      next_visit_date: "2023/06/20",
      km: 125000,
      address: {
        city: "Riyadh",
        province: "Riyadh",
      },
    },
    {
      id: 5001801,
      user: {
        id: 6009586,
        first_name: "Fatima",
        last_name: "Al-Ghamdi",
        driver_phone_number: "0559876543",
      },
      product: {
        name: "Hyundai Air Filter for Accent",
        category: "Air",
      },
      payable_amount: 89.0,
      phone_number: "0123456789",
      user_car: {
        car_name: "Hyundai Accent",
        plate_number: "د س ك ٤٥٦٧ / D S K 4567",
        initial_km: 45000,
      },
      service_center: {
        name: "Jeddah Express Lube",
        phone_number: "0123456789",
        address: "Jeddah - Al-Hamra - Prince Sultan St",
      },
      operator: {
        operator_id: 5004567,
        operator_name: "Fatima Al-Ghamdi",
        operator_username: "0559876543",
      },
      delivery_date: "2024/11/02",
      visit_date: "2024/11/03",
      next_visit_date: "2024/12/01",
      km: 48200,
      address: {
        city: "Jeddah",
        province: "Makkah",
      },
    },
    {
      id: 5001802,
      user: {
        id: 6009587,
        first_name: "Ahmad",
        last_name: "Al-Otaibi",
        driver_phone_number: "0531122334",
      },
      product: {
        name: "Isuzu Brake Pads for NPR",
        category: "Brakes",
      },
      payable_amount: 380.0,
      phone_number: "0134567890",
      user_car: {
        car_name: "Isuzu NPR",
        plate_number: "ر ع ل ٠٠١٢ / R A L 0012",
        initial_km: 120000,
      },
      service_center: {
        name: "Eastern Fleet Maintenance",
        phone_number: "0134567890",
        address: "Dammam - Industrial Area 2",
      },
      operator: {
        operator_id: 5007890,
        operator_name: "Ahmad Al-Zahrani",
        operator_username: "0531122334",
      },
      delivery_date: "2022/03/16",
      visit_date: "2022/03/17",
      next_visit_date: "2022/04/14",
      km: 135000,
      address: {
        city: "Dammam",
        province: "Eastern Province",
      },
    },
    {
      id: 5001803,
      user: {
        id: 6009588,
        first_name: "Khalid",
        last_name: "Al-Harbi",
        driver_phone_number: "0594455667",
      },
      product: {
        name: "Nissan Fuel Filter for Patrol",
        category: "Fuel",
      },
      payable_amount: 210.75,
      phone_number: "0129876543",
      user_car: {
        car_name: "Nissan Patrol",
        plate_number: "ق ه م ٣٣٣٣ / Q H M 3333",
        initial_km: 85000,
      },
      service_center: {
        name: "Makkah Auto Care Center",
        phone_number: "0129876543",
        address: "Mecca - Al-Aziziyah District",
      },
      operator: {
        operator_id: 5002233,
        operator_name: "Khalid Al-Otaibi",
        operator_username: "0594455667",
      },
      delivery_date: "2025/01/11",
      visit_date: "2025/01/12",
      next_visit_date: "2025/02/09",
      km: 87000,
      address: {
        city: "Mecca",
        province: "Makkah",
      },
    },
    {
      id: 5001804,
      user: {
        id: 6009589,
        first_name: "Nora",
        last_name: "Al-Qahtani",
        driver_phone_number: "0547788990",
      },
      product: {
        name: "Mercedes Coolant 5L",
        category: "Cooling",
      },
      payable_amount: 450.0,
      phone_number: "0145678901",
      user_car: {
        car_name: "Mercedes-Benz Sprinter",
        plate_number: "ط ن و ٩٩٩٩ / T N W 9999",
        initial_km: 98000,
      },
      service_center: {
        name: "Madinah Commercial Vehicles",
        phone_number: "0145678901",
        address: "Madinah - Qiblatain Road",
      },
      operator: {
        operator_id: 5009900,
        operator_name: "Nora Al-Harbi",
        operator_username: "0547788990",
      },
      delivery_date: "2024/10/05",
      visit_date: "2024/10/06",
      next_visit_date: "2024/10/30",
      km: 101500,
      address: {
        city: "Madinah",
        province: "Madinah",
      },
    },
  ]);
  const [search, setSearch] = useState(params.search);
  const [form] = Form.useForm();

  const getCarsServiceReport = (page, disableFilters = false) => {
    // setLoading(true);
    const formItems = form.getFieldsValue();
    const form_purchase_start_date =
      formItems.purchase_date.length &&
      formItems.purchase_date[0] &&
      typeof formItems.purchase_date[0] === "object"
        ? formatAntdJalaliDate(formItems.purchase_date[0])
        : formItems.purchase_date
        ? formItems.purchase_date[0]
        : null;

    const form_purchase_end_date =
      formItems.purchase_date.length &&
      formItems.purchase_date[1] &&
      typeof formItems.purchase_date[1] === "object"
        ? formatAntdJalaliDate(formItems.purchase_date[1])
        : formItems.purchase_date
        ? formItems.purchase_date[1]
        : null;
    const filters = {
      search,
      ...((page || carsServiceReport?.pagination?.page) && {
        page: page || carsServiceReport?.pagination?.page,
      }),
      province_id: formItems.province_id,
      city_id: formItems.city_id,
      operator_id:
        store?.user?.user_type === "company_employee"
          ? store?.user?.id
          : formItems.operator_id,
      user_id: formItems.user_id,
      product_category_id: formItems.product_category_id,
      purchase_start_date: form_purchase_start_date,
      purchase_end_date: form_purchase_end_date,
    };
    if (!disableFilters)
      history.push({
        pathname: "/cars-service-report/",
        search: stringify(filters),
      });
    // API.get
    //   .get_car_services_report(disableFilters ? {} : filters)
    //   .then((response) => {
    //     if (response.success) {
    //       setCarsServiceReport(response);
    //     } else {
    //       Note.error(response.message);
    //     }
    //     setLoading(false);
    //   });
  };

  const exportCarServicesReport = () => {
    const formItems = form.getFieldsValue();
    const form_purchase_start_date =
      formItems.purchase_date.length &&
      formItems.purchase_date[0] &&
      typeof formItems.purchase_date[0] === "object"
        ? formatAntdJalaliDate(formItems.purchase_date[0])
        : formItems.purchase_date
        ? formItems.purchase_date[0]
        : null;

    const form_purchase_end_date =
      formItems.purchase_date.length &&
      formItems.purchase_date[1] &&
      typeof formItems.purchase_date[1] === "object"
        ? formatAntdJalaliDate(formItems.purchase_date[1])
        : formItems.purchase_date
        ? formItems.purchase_date[1]
        : null;
    const filters = {
      search,
      ...(carsServiceReport?.pagination?.page && {
        page: carsServiceReport?.pagination?.page,
      }),
      province_id: formItems.province_id,
      city_id: formItems.city_id,
      operator_id:
        store?.user?.user_type === "company_employee"
          ? store?.user?.id
          : formItems.operator_id,
      user_id: formItems.user_id,
      product_category_id: formItems.product_category_id,
      purchase_start_date: form_purchase_start_date,
      purchase_end_date: form_purchase_end_date,
      get_report: true,
    };
    // API.get
    //   .car_services_report(filters)
    //   .then((response) => {
    //     if (response.status === 200) {
    //       return response.blob();
    //     } else {
    //       Note.error(response.message);
    //     }
    //   })
    //   .then((blob) => {
    //     FileSaver.saveAs(blob, `car-services-report.xlsx`);
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //   });
  };

  const getCategories = () => {
    // API.get.product_categories().then((response) => {
    //   if (response.success) {
    //     setCategories(response.data);
    //   } else {
    //     Note.error(response.message);
    //   }
    // });
  };

  const getUserCars = () => {
    // API.get.company_employee_cars().then((response) => {
    //   if (response.success) {
    //     setCars(response);
    //   } else {
    //     Note.error(response.message);
    //   }
    // });
  };

  const changePage = (page) => {
    setCarsServiceReport({
      ...carsServiceReport,
      pagination: {
        ...carsServiceReport.pagination,
        page,
      },
    });
    getCarsServiceReport(page);
  };

  const getUsers = (province_id, city_id) => {
    const filters = {
      province_id: province_id ? province_id : null,
      city_id: city_id ? city_id : null,
    };
    // API.get.company_employee(filters).then((response) => {
    //   if (response.success) {
    //     setUsers(response.data);
    //   }
    // });
  };

  useEffect(() => {
    getCarsServiceReport();
    getCategories();
    getUserCars();
    if (store?.user?.user_type !== "company_employee") getUsers();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (params.province_id && !cities.length) {
      onChangeProvince(params.province_id, null, setCities);
    }
    // eslint-disable-next-line
  }, [history]);

  return {
    loading,
    carsServiceReport,
    provinces,
    cities,
    setCities,
    categories,
    cars,
    users,
    getCarsServiceReport,
    exportCarServicesReport,
    form,
    search,
    setSearch,
    changePage,
    getUsers,
  };
};

export default useCarsServiceReport;
